// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingStatusResponse

import { BookingStatus, GuaranteeStatus, PaymentStatus } from './enums.gen';

export type WidgetBookingStatusApiResponse = {
	status: BookingStatus;
	guaranteeStatus: GuaranteeStatus | null;
	guaranteeFailureMessage: string | null;
	guaranteeAmount: number | null;
	paymentStatus: PaymentStatus | null;
};

export type WidgetBookingStatus = {
	status: BookingStatus;
	guaranteeStatus: GuaranteeStatus | null;
	guaranteeFailureMessage: string | null;
	guaranteeAmount: number | null;
	paymentStatus: PaymentStatus | null;
};

export function hydrateWidgetBookingStatus(data: WidgetBookingStatusApiResponse): WidgetBookingStatus {
	return { ...data };
}